export const createUrl = (data) => {



    if (data.type) {
        return `?creator=${data.type}`
    }
    else return ""; // window.location = '/'

}